/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Provider } from '../models/Provider';

export class CloudProviderFilters {
  /**
  * Matches if any value in this list equals `cloudProvider`.
  */
  '_in'?: Array<Provider>;
  /**
  * Matches if none of the values in this list equal `cloudProvider`.
  */
  'notIn'?: Array<Provider>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "_in",
      "baseName": "in",
      "type": "Array<Provider>",
      "format": ""
    },
    {
      "name": "notIn",
      "baseName": "notIn",
      "type": "Array<Provider>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CloudProviderFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

